import { render, staticRenderFns } from "./ProductMobile.vue?vue&type=template&id=89072636"
import script from "./ProductMobile.vue?vue&type=script&lang=js"
export * from "./ProductMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports